/**
 * 工具
 */
export const handleProvinces = (list = []) => {
  return list.map((item) => {
    return {
      name: item,
      cities: []
    }
  })
}

export const handleCityList = (list = []) => {
  let defaultRegion = {}
  const regionList = []
  for (let i = 0; i < list.length; i++) {
    const city = list[i]

    // 获取默认城市
    if (city.defaultCity) {
      defaultRegion = {
        province: city.province,
        city: city.city
      }
    }

    const findProvince = regionList.find(item => {
      if (city.province === item.name) return item
    })
    // 列表中不存在该省
    if (!findProvince) {
      const provinceObj = {
        name: city.province,
        cities: [
          {
            name: city.city,
            position: city.position,
            defaultCity: city.defaultCity,
            code: city.code
          }
        ]
      }
      regionList.push(provinceObj)
    }

    // 列表中存在该省
    if (findProvince) {
      findProvince.cities.push({
        name: city.city,
        position: city.position,
        defaultRegion: city.defaultRegion,
        code: city.code
      })
    }
  }
  return {
    defaultRegion,
    regionList
  }
}

// 英文/中文字母排序
export const letterCompare = (propName) => {
  return (last,next) => {
    const lastVal = last[propName]
    const nextVal = next[propName]
    return lastVal.localeCompare(nextVal)
  }
}
